import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "detection-per-domain",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Compare detections across monitored domains.",
    domain: "detections",
    visual: "Bar chart",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "chart" },
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
